<img
  class="avatar"
  [src]="this.photoUrl"
  alt="Profile picture of the logged-in user"
/>
